import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import BreadCrumb from '../utility/breadCrumb';
import Results from  '../body/Search';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="Search" 
        linkname="Search" 
        linklevel="1" 
        linktoone="" 
        linknameone=""
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Results></Results>
    </>
  );
}

export default Index;
